import { FC, useContext } from 'react';
import { BookingEventDateItem } from '../../Types/Event';
import { EventsContext } from '../../Service/Context/EventsContext';
import EventAppointmentItem from './EventAppointmentItem';
import EventDateItem from './EventDateItem';
import EventDateItemMultiple from './EventDateItemMultiple';

const EventItem: FC<{ bookingEventDate: BookingEventDateItem }> = ({ bookingEventDate }) => {
  const { filter } = useContext(EventsContext) ?? {};
  const { agencyModeActive } = filter ?? { agencyModeActive: false };
  const { type } = bookingEventDate;

  if (type === 'APPOINTMENT') {
    if (agencyModeActive) return null;
    return <EventAppointmentItem bookingEventDate={bookingEventDate} />;
  }
  return <EventDateItem bookingEventDate={bookingEventDate} />;
};

export const EventItemV2: FC<{ bookingEventDate: BookingEventDateItem }> = ({ bookingEventDate }) => {
  const { type } = bookingEventDate;

  if (type === 'APPOINTMENT') {
    return <EventAppointmentItem bookingEventDate={bookingEventDate} />;
  }
  return <EventDateItem bookingEventDate={bookingEventDate} />;
};

export const EventItemMultiple: FC<{ bookingEventDates: BookingEventDateItem[] }> = ({ bookingEventDates }) => (
  <EventDateItemMultiple bookingEventDates={bookingEventDates} />
);

export default EventItem;
